export class VersionUtil {
    static isVersionAtLeast(baseVersion: string, requiredVersion: string): boolean {
        if (!baseVersion || !requiredVersion)
            return false;

        let addonVersions
            = baseVersion.split('.')
                //filter out freak-versions like 3.8.1-rc1 (gets filtered to 3.8)
                .filter((item) => !!parseInt(item));
        let requiredVersions = requiredVersion.split('.');

        //Prevent edge cases:
        //If versions have a different length, we fill up with 0
        // -->If we compare 1.8.3 and 1.8, assume it's 1.8.0
        while (addonVersions.length > requiredVersions.length) {
            requiredVersions.push('0');
        }
        while (requiredVersions.length > addonVersions.length) {
            addonVersions.push('0');
        }

        //Compare Versions
        //Default is true --> if versions are equal, result is true
        let result: boolean = true;
        for (let i = 0; i <= requiredVersions.length; i++) {
            let addonVersionNumber = parseInt(addonVersions[i]);
            let requiredVersionNumber = parseInt(requiredVersions[i]);

            if (addonVersionNumber > requiredVersionNumber) {
                break;
            }

            if (addonVersionNumber < requiredVersionNumber) {
                result = false;
                break;
            }
        }

        return result;
    }
}
